const hdrSearch = () => {
	const hdrSearchBtn		= document.querySelector('[data-btn="hdr-search"]'),
		  hdrSearchBlock 	= document.querySelector('[data-search="hdr-search"]');

	hdrSearchBtn.addEventListener('click', ()=>{
		hdrSearchBlock.classList.add('active');
		hdrSearchBlock.classList.add('slide-up-long_percent');
		addEventListener('click', closeModal);
	});

	hdrSearchBlock.addEventListener('click', (e)=>{
		let target = e.target;

		if(target.classList.contains('close-modal')) {
			hdrSearchBlock.classList.remove('active');
			hdrSearchBlock.classList.remove('slide-up-long_percent');
			removeEventListener('click', closeModal);
		}
	});

	// закрыть вне блока
	function closeModal(event) {
		let target = event.target;

		if(!hdrSearchBlock.contains(target) && target.dataset.btn != 'hdr-search') {
			hdrSearchBlock.classList.remove('active');
			hdrSearchBlock.classList.remove('slide-up-long_percent');
			removeEventListener('click', closeModal);
		}
	}
}

export default hdrSearch;